'use strict';

wbApp.controller('SmsCtrl', ['$scope', '$modal', '$translate', '$filter', 'recipientSvc', 'messagesSvc', 'tenantSettingSvc',
function ($scope, $modal, $translate, $filter, recipientSvc, messagesSvc, tenantSettingSvc) {

    $scope.fromDate = moment().startOf('month').toDate();
    $scope.toDate = moment().endOf('month').toDate();

    $scope.enableSMSSupport = tenantSettingSvc.settings.enableSMSSupport;
    $scope.smsMessages = messagesSvc.getSmsHistoryByDateRage($scope.fromDate, $scope.toDate);

    $scope.gridSettings = {
        columns: [
            { dataField: 'createdAt', caption: $translate.instant('TXT_LBL_CREATED_AT'), dataType: 'date', format: 'shortDateShortTime', width: '140px', sortOrder: 'desc' },
            {
                dataField: 'recipient',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.recipient);
                },
                width: '130px'
            },
            { dataField: 'noOfSms', caption: $translate.instant('TXT_LBL_NO_OF_SMS'), dataType: 'number', width: '90px' },
            { dataField: 'text', caption: $translate.instant('TXT_LBL_TEXT'), dataType: 'string' },
            { dataField: 'errorText', caption: $translate.instant('TXT_LBL_ERROR_CODE'), dataType: 'string', width: '130px' }
        ]
    }

    //$scope.gridOptions = {
    //    sortInfo: { fields: ['createdAt'], directions: ['dsc'] },
    //    // > 992
    //    largeColumnDefs: [{ field: 'createdAt', displayName: "TXT_LBL_CREATED_AT", width: '120px', cellFilter: "date:'short'" },                          
    //                      { field: 'recipient', displayName: "TXT_LBL_PHONE", width: '120px', cellFilter: 'phone' },
    //                      { field: 'noOfSms', displayName: "TXT_LBL_NO_OF_SMS", width: '90px' },
    //                      { field: 'text', displayName: "TXT_LBL_TEXT" },
    //                      { field: 'errorText', displayName: "TXT_LBL_ERROR_CODE", width: '130px' }
    //    ]
    //};

    $scope.onFromDateChange = function (fromDate) {
        if (fromDate) {
            $scope.smsMessages = messagesSvc.getSmsHistoryByDateRage(fromDate, $scope.toDate);
        }
    }

    $scope.onToDateChange = function (toDate) {
        if (toDate) {
            $scope.smsMessages = messagesSvc.getSmsHistoryByDateRage($scope.fromDate, toDate);
        }
    }

    $scope.selectedRow = {};

    $scope.onRowSelected = function (data) {
        if (!angular.equals($scope.selectedRow, data)) {
            $scope.selectedRow = data;
        }
    }

    $scope.onNewSms = function () {
        detailDialogPromise.$promise.then(function () {
            $scope.clearAll();
            detailDialogPromise.show();
        });
    }

    $scope.detailError = null;

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "messages/sms-detail-tabs/home.html"
    }];

    $scope.tabs.activeTab = 0;

    var detailDialogPromise = $modal({
        templateUrl: 'messages/sms-detai.html',
        show: false,
        scope: $scope
    });

    $scope.addAddress = function () {
        addressSelectorPromise.$promise.then(function () {
            $scope.recipient = recipientSvc.createRecipientModel();
            addressSelectorPromise.show();
        });
    }

    $scope.onAddAddress = function (recipient)
    {
        $scope.recipientList.push(recipient);
    }

    $scope.smsText = '';
    $scope.recipientList = [];

    var addressSelectorPromise = $modal({
        templateUrl: 'messages/address-selector.html',
        show: false,
        scope: $scope
    });

    $scope.clearAll = function () {
        $scope.recipientList.length = 0;
        $scope.smsText = '';
    }

    $scope.sendMessage = function (recipientList, smsText) {
        messagesSvc.sendSms(recipientList, smsText)
            .then(function () {
                $scope.clearAll();
                detailDialogPromise.hide();
            });
    }

}]);
